import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { setAxiosAuthToken } from "../utils/axiosInstance"; // path apne project ke hisaab se adjust kar lena
const AppContext = React.createContext();

export const AppProvider = ({ children }) => {
    //development
    // const [baseUrl, setBaseUrl] = useState("http://127.0.0.1:8000/api");
    // const [baseUrlForFiles, setBaseUrlForFiles] = useState("http://127.0.0.1:8000/storage");
    //production
    const [baseUrlForFiles, setBaseUrlForFiles] = useState("https://ggcwlibrary.btsportfolio2026.com/backend/public/storage");
    const [baseUrl, setBaseUrl] = useState("https://ggcwlibrary.btsportfolio2026.com/backend/public/api");
    
    const [loggedInUser, setLoggedInUser] = useState(null);
    const [selectedBookForReservation, setSelectedBookForReservation] = useState();
    const Navigate = useNavigate();

    // ── AUTH ──
    const [authToken, setAuthToken] = useState(() => {
        return localStorage.getItem("authToken") || "";
    });
    const [userType, setUserType] = useState("");
    const [authLoading, setAuthLoading] = useState(true);

    useEffect(() => {
        if (authToken) {
            localStorage.setItem("authToken", authToken);
        } else {
            localStorage.removeItem("authToken");
        }
        setAxiosAuthToken(authToken);
    }, [authToken]);

    const decodeUserTypeFromToken = (token) => {
        try {
            const payload = JSON.parse(atob(token.split(".")[1]));
            return payload.guard || null;
        } catch (e) {
            return null;
        }
    };
    const isTokenExpired = (token) => {
    if (!token) return true;

    try {
        const payload = JSON.parse(atob(token.split(".")[1]));

        // exp seconds mein hota hai
        return payload.exp * 1000 < Date.now();
    } catch (err) {
        return true;
    }
    };
//     useEffect(() => {

//     if (!authToken) return;

//     const interval = setInterval(() => {

//         if (isTokenExpired(authToken)) {

//             alert("Your session has expired. Please login again.");

//             logoutUser();

//         }

//     }, 5000); // har 5 second check karega

//     return () => clearInterval(interval);

//    }, [authToken]);

    useEffect(() => {
     const restoreSession = () => {
  setAuthLoading(true);

  if (!authToken) {
    setAuthLoading(false);
    return;
  }

  const decodedType = decodeUserTypeFromToken(authToken);

  if (!decodedType) {
    logoutUser();
    return;
  }

  setUserType(decodedType);

  const meRouteByType = {
    student: "/student/auth/me",
    teacher: "/teacher/auth/me",
    admin: "/admin/auth/me",
  };

  const route = meRouteByType[decodedType];

  if (!route) return;

  axios
    .get(`${baseUrl}${route}`, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
    .then((res) => {
      const data = res.data;

      if (data.success) {
    setLoggedInUser(data.student || data.teacher || data.admin);
    setAuthLoading(false);
    } else {
    setAuthLoading(false);
    logoutUser();
   }
    })
   .catch((error) => {
  console.log(error);
  setAuthLoading(false);
  logoutUser();
     });
       };

        restoreSession();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //////////////  REGEX  //////////////

const fullNameRegExp = /^[A-Za-z]+(?: [A-Za-z]+)*$/;

const emailRegExp =
/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

const passwordRegExp =
/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#._-])[A-Za-z\d@$!%*?&#._-]{8,}$/;

const phoneNumberRegExp =
/^03\d{9}$/;

const rollNoRegExp =
/^[A-Za-z]{2,6}-[0-9]{2,6}$/;

const disputeSubjectRegExp =
/^[A-Za-z0-9\s.,!?()&'-]{5,100}$/;

const disputeDescriptionRegExp =
/^[A-Za-z0-9\s.,!?()&'"\-:\n]{15,500}$/;

const noteTitleRegExp =
/^[A-Za-z0-9\s.,()&'-]{5,100}$/;

const subjectRegExp =
/^[A-Za-z\s]{2,50}$/;

const bookTitleRegExp =
/^[A-Za-z0-9\s.,()&'-]{3,100}$/;

const bookAuthorRegExp =
/^[A-Za-z\s.'-]{3,60}$/;

const accessionNoRegExp =
/^[A-Za-z0-9-]{3,30}$/;
const blogTitleRegExp =
/^[A-Za-z0-9\s.,()&'-]{5,120}$/;

const blogExcerptRegExp =
/^[A-Za-z0-9\s.,!?()&'"-]{10,300}$/;

const blogContentRegExp =
/^[\s\S]{20,5000}$/;
const faqQuestionRegExp =
/^[A-Za-z0-9\s.,!?()&'"%:/+-]{10,200}$/;

const faqAnswerRegExp =
/^[\s\S]{20,1000}$/;


    //////////////  CHECKER  //////////////
    const regExpChecker = (type, input) => {

    input = input.trim();

    switch (type) {

        case "fullName":

            if (!fullNameRegExp.test(input)) {
                return "Full name should contain only letters and spaces.";
            }

            if (input.length < 3 || input.length > 50) {
                return "Full name must be between 3 and 50 characters.";
            }

            break;

        case "email":

            if (!emailRegExp.test(input)) {
                return "Please enter a valid email address.";
            }

            break;

        case "password":

            if (!passwordRegExp.test(input)) {
                return "Password must contain at least 8 characters, one uppercase letter, one lowercase letter, one number, and one special character.";
            }

            break;

        case "phoneNumber":

            if (!phoneNumberRegExp.test(input)) {
                return "Phone number must be in the format 03XXXXXXXXX.";
            }

            break;

       case "rollNo":

    if (!rollNoRegExp.test(input)) {
        return "Roll No must be in the format DISCIPLINE-NUMBER (e.g. CS-21, FA-1412).";
    }

    break;

            case "disputeSubject":

    if (!disputeSubjectRegExp.test(input)) {
        return "Subject must be between 5 and 100 characters.";
    }

    break;

case "disputeDescription":

    if (!disputeDescriptionRegExp.test(input)) {
        return "Description must be between 15 and 500 characters.";
    }

    break;
     case "noteTitle":

    if (!noteTitleRegExp.test(input)) {
        return "Title must be between 5 and 100 characters.";
    }

    break;

case "subject":

    if (!subjectRegExp.test(input)) {
        return "Subject must contain only letters and be between 2 and 50 characters.";
    }

    break;

    case "bookTitle":

    if (!bookTitleRegExp.test(input)) {
        return "Book title must be between 3 and 100 characters.";
    }

    break;

case "bookAuthor":

    if (!bookAuthorRegExp.test(input)) {
        return "Author name must be between 3 and 60 characters.";
    }

    break;

case "accessionNo":

    if (!accessionNoRegExp.test(input)) {
        return "Accession No must be between 3 and 30 characters.";
    }

    break;
     case "blogTitle":

    if (!blogTitleRegExp.test(input)) {
        return "Blog title must be between 5 and 120 characters.";
    }

    break;

case "blogExcerpt":

    if (!blogExcerptRegExp.test(input)) {
        return "Excerpt must be between 10 and 300 characters.";
    }

    break;

case "blogContent":

    if (!blogContentRegExp.test(input)) {
        return "Content must be between 20 and 5000 characters.";
    }

    break;
    case "faqQuestion":

    if (!faqQuestionRegExp.test(input)) {
        return "Question must be between 10 and 200 characters.";
    }

    break;

case "faqAnswer":

    if (!faqAnswerRegExp.test(input)) {
        return "Answer must be between 20 and 1000 characters.";
    }

    break;
        default:
            return null;
    }
    

    return null;

};

    //////////////  LOGIN VALIDATION (Email based — teacher/admin)  //////////////
    const validateLoginForm = ({ email, password }) => {
        const errors = {};

        if (!email || email.trim() === "") {
            errors.email = "Email is required.";
        } else {
            const err = regExpChecker("email", email.trim());
            if (err) errors.email = err;
        }

        if (!password || password.trim() === "") {
            errors.password = "Password is required.";
        } else {
            const err = regExpChecker("password", password.trim());
            if (err) errors.password = err;
        }

        return errors;
    };

    //////////////  STUDENT LOGIN VALIDATION (Roll No based)  //////////////
    const validateStudentLoginForm = ({ roll_no, password }) => {
        const errors = {};

        if (!roll_no || roll_no.trim() === "") {
            errors.roll_no = "Roll No is required.";
        } else {
            const err = regExpChecker("rollNo", roll_no.trim());
            if (err) errors.roll_no = err;
        }

        if (!password || password.trim() === "") {
            errors.password = "Password is required.";
        } else {
            const err = regExpChecker("password", password.trim());
            if (err) errors.password = err;
        }

        return errors;
    };

    //////////////  SESSION VALIDATION (Program-based year range)  //////////////
    const INTERMEDIATE_PROGRAMS = [
        "FA",
        "FA (IT)",
        "FSC (Pre Engineering)",
        "FSC (Pre Medical)",
        "ICS (Physics)",
    ];

    const validateSessionByProgram = (session, program) => {
        const sessionRegExp = /^(\d{4})-(\d{4})$/;
        const trimmed = session.trim();
        const match = trimmed.match(sessionRegExp);

        if (!match) {
            return "Session must be in the format YYYY-YYYY (e.g. 2022-2026).";
        }

        const startYear = parseInt(match[1], 10);
        const endYear = parseInt(match[2], 10);
        const currentYear = new Date().getFullYear();

        const isIntermediate = INTERMEDIATE_PROGRAMS.includes(program);
        const expectedDuration = isIntermediate ? 2 : 4;

        if (endYear - startYear !== expectedDuration) {
            return `Session duration must be ${expectedDuration} years for this program (e.g. ${currentYear}-${currentYear + expectedDuration}).`;
        }

        const earliestAllowedStartYear = currentYear - expectedDuration;

        if (startYear < earliestAllowedStartYear) {
            return `Session cannot start more than ${expectedDuration} years ago for this program.`;
        }

        return null;
    };
     
    //////////////  REGISTER VALIDATION  //////////////
    const validateRegisterForm = ({
        fullName,
        email,
        phone,
        roll_no,
        program,
        session,
        password,
        confirmPassword,
    }) => {
        const errors = {};

        if (!fullName || fullName.trim() === "") {
            errors.fullName = "Full name is required.";
        } else {
            const err = regExpChecker("fullName", fullName.trim());
            if (err) errors.fullName = err;
        }

        if (!email || email.trim() === "") {
            errors.email = "Email is required.";
        } else {
            const err = regExpChecker("email", email.trim());
            if (err) errors.email = err;
        }

        if (!phone || phone.trim() === "") {
            errors.phone = "Phone number is required.";
        } else {
            const err = regExpChecker("phoneNumber", phone.trim());
            if (err) errors.phone = err;
        }

        if (!roll_no || roll_no.trim() === "") {
            errors.roll_no = "Roll No is required.";
        } else {
            const err = regExpChecker("rollNo", roll_no.trim());
            if (err) errors.roll_no = err;
        }

        if (!program || program.trim() === "") {
            errors.program = "Program is required.";
        }

        if (!session || session.trim() === "") {
            errors.session = "Session is required.";
        } else {
            const sessionErr = validateSessionByProgram(session.trim(), program);
            if (sessionErr) errors.session = sessionErr;
        }

        if (!password || password.trim() === "") {
            errors.password = "Password is required.";
        } else {
            const err = regExpChecker("password", password.trim());
            if (err) errors.password = err;
        }

        if (!confirmPassword || confirmPassword.trim() === "") {
            errors.confirmPassword = "Please confirm your password.";
        } else if (password !== confirmPassword) {
            errors.confirmPassword = "Passwords do not match.";
        }

        return errors;
    };
    const validateBookForm = ({
    title,
    author,
    accessionNo,
    program,
    totalCopies,
    coverImage,
}) => {

    const errors = {};

    if (!title || title.trim() === "") {
        errors.title = "Book title is required.";
    } else {
        const err = regExpChecker("bookTitle", title.trim());
        if (err) errors.title = err;
    }

    if (!author || author.trim() === "") {
        errors.author = "Author name is required.";
    } else {
        const err = regExpChecker("bookAuthor", author.trim());
        if (err) errors.author = err;
    }

    if (!accessionNo || accessionNo.trim() === "") {
        errors.accessionNo = "Accession No is required.";
    } else {
        const err = regExpChecker("accessionNo", accessionNo.trim());
        if (err) errors.accessionNo = err;
    }

    if (!program) {
        errors.program = "Please select a program.";
    }

    if (!totalCopies) {
        errors.totalCopies = "Total copies is required.";
    } else if (isNaN(totalCopies) || Number(totalCopies) < 1) {
        errors.totalCopies = "Total copies must be at least 1.";
    }

    if (!coverImage) {
        errors.coverImage = "Please upload a cover image.";
    }

    return errors;
};

const validateEBookForm = ({
    title,
    author,
    department,
    coverImage,
    pdfFile,
}) => {

    const errors = {};

    if (!title || title.trim() === "") {
        errors.title = "Book title is required.";
    } else {
        const err = regExpChecker("bookTitle", title.trim());
        if (err) errors.title = err;
    }

    if (!author || author.trim() === "") {
        errors.author = "Author name is required.";
    } else {
        const err = regExpChecker("bookAuthor", author.trim());
        if (err) errors.author = err;
    }

    if (!department) {
        errors.department = "Please select a department.";
    }

    if (!coverImage) {
        errors.coverImage = "Please upload a cover image.";
    }

    if (!pdfFile) {
        errors.pdfFile = "Please upload a PDF file.";
    }

    return errors;
};
const validateBlogForm = ({
    title,
    author,
    category,
    coverImage,
    excerpt,
    tags,
    content,
}) => {

    const errors = {};

    if (!title || title.trim() === "") {
        errors.title = "Blog title is required.";
    } else {
        const err = regExpChecker("blogTitle", title.trim());
        if (err) errors.title = err;
    }

    if (!author || author.trim() === "") {
        errors.author = "Author name is required.";
    } else {
        const err = regExpChecker("bookAuthor", author.trim());
        if (err) errors.author = err;
    }

    if (!category) {
        errors.category = "Please select a category.";
    }

    if (!coverImage) {
        errors.coverImage = "Please upload a cover image.";
    }

    if (!excerpt || excerpt.trim() === "") {
        errors.excerpt = "Excerpt is required.";
    } else {
        const err = regExpChecker("blogExcerpt", excerpt.trim());
        if (err) errors.excerpt = err;
    }

    if (!tags || tags.length === 0) {
        errors.tags = "Please add at least one tag.";
    }

    if (!content || content.trim() === "") {
        errors.content = "Content is required.";
    } else {
        const err = regExpChecker("blogContent", content.trim());
        if (err) errors.content = err;
    }

    return errors;
};
const validateFaqForm = ({
    audience,
    question,
    answer,
}) => {

    const errors = {};

    if (!audience || audience.trim() === "") {

        errors.audience = "Please select audience.";

    }

    if (!question || question.trim() === "") {

        errors.question = "Question is required.";

    } else {

        const err = regExpChecker(
            "faqQuestion",
            question.trim()
        );

        if (err) errors.question = err;

    }

    if (!answer || answer.trim() === "") {

        errors.answer = "Answer is required.";

    } else {

        const err = regExpChecker(
            "faqAnswer",
            answer.trim()
        );

        if (err) errors.answer = err;

    }

    return errors;
};

    //////////////  TEACHER REGISTER VALIDATION  //////////////
    const validateTeacherRegisterForm = ({ name, email, phone, password }) => {
        const errors = {};

        if (!name || name.trim() === "") {
            errors.name = "Full name is required.";
        } else {
            const err = regExpChecker("fullName", name.trim());
            if (err) errors.name = err;
        }

        if (!email || email.trim() === "") {
            errors.email = "Email is required.";
        } else {
            const err = regExpChecker("email", email.trim());
            if (err) errors.email = err;
        }

        if (!phone || phone.trim() === "") {
            errors.phone = "Phone number is required.";
        } else {
            const err = regExpChecker("phoneNumber", phone.trim());
            if (err) errors.phone = err;
        }

        if (!password || password.trim() === "") {
            errors.password = "Password is required.";
        } else {
            const err = regExpChecker("password", password.trim());
            if (err) errors.password = err;
        }

        return errors;
    };
    const validateSubAdminRegisterForm = ({
    name,
    email,
    role,
    status,
    password,
}) => {

    const errors = {};

    if (!name || name.trim() === "") {
        errors.name = "Full name is required.";
    } else {
        const err = regExpChecker("fullName", name.trim());
        if (err) errors.name = err;
    }

    if (!email || email.trim() === "") {
        errors.email = "Email is required.";
    } else {
        const err = regExpChecker("email", email.trim());
        if (err) errors.email = err;
    }

    if (!role || role.trim() === "") {
        errors.role = "Please select a role.";
    }

    if (!status || status.trim() === "") {
        errors.status = "Please select status.";
    }

    if (!password || password.trim() === "") {
        errors.password = "Password is required.";
    } else {
        const err = regExpChecker("password", password.trim());
        if (err) errors.password = err;
    }

    return errors;
};

    const validateTeacherNotesForm = ({
    title,
    subject,
    pdfFile,
}) => {

    const errors = {};

    if (!title || title.trim() === "") {

        errors.title = "Title is required.";

    } else {

        const err = regExpChecker("noteTitle", title.trim());

        if (err) errors.title = err;

    }

    if (!subject || subject.trim() === "") {

        errors.subject = "Subject is required.";

    } else {

        const err = regExpChecker("subject", subject.trim());

        if (err) errors.subject = err;

    }

    if (!pdfFile) {

        errors.pdfFile = "PDF file is required.";

    } else {

        if (pdfFile.type !== "application/pdf") {

            errors.pdfFile = "Only PDF files are allowed.";

        }

        if (pdfFile.size > 5 * 1024 * 1024) {

            errors.pdfFile = "PDF size must not exceed 5 MB.";

        }

    }

    return errors;

};
    ////////////// DISPUTE VALIDATION //////////////

const validateDisputeForm = ({
    subject,
    book,
    category,
    description,
}) => {

    const errors = {};

    if (!subject || subject.trim() === "") {

        errors.subject = "Subject is required.";

    } else {

        const err = regExpChecker("disputeSubject", subject.trim());

        if (err) errors.subject = err;

    }

    if (!book) {

        errors.book = "Please select a related book.";

    }

    if (!category) {

        errors.category = "Please select a category.";

    }

    if (!description || description.trim() === "") {

        errors.description = "Description is required.";

    } else {

        const err = regExpChecker(
            "disputeDescription",
            description.trim()
        );

        if (err) errors.description = err;

    }

    return errors;
};

    //////////////  LOGOUT  //////////////
    const logoutUser = () => {
        setAuthToken("");
        setUserType("");
        setLoggedInUser(null);
        setSelectedBookForReservation(null);
        Navigate("/");
    };

    return (
        <AppContext.Provider
            value={{
                baseUrl,
                baseUrlForFiles,
                authToken,
                setAuthToken,
                authLoading,
                Navigate,
                regExpChecker,
                validateLoginForm,
                validateStudentLoginForm,
                validateSessionByProgram,
                validateRegisterForm,
                validateTeacherRegisterForm,
                validateEBookForm,
                 validateBlogForm,
                 validateFaqForm,
                validateDisputeForm,
                validateTeacherNotesForm,
                validateSubAdminRegisterForm,
                validateBookForm,
                setLoggedInUser,
                loggedInUser,
                setSelectedBookForReservation,
                userType,
                setUserType,
                selectedBookForReservation,
                logoutUser
            }}
        >
            {children}
        </AppContext.Provider>
    );
};

export default AppContext;